import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Typography, TextField, Button } from '@material-ui/core'

import PageTitle from '../global/PageTitle/PageTitle'
import { findTaskBySlug } from '../Navbar/components/searchbar/SearchbarData'
import { supervisoryOrganizations } from '../../data/organizations'
import './TaskPage.css'

// Generic task form. Every task the header search can find opens here unless
// it has a dedicated flow of its own, so no search result is a dead end (QA issue 1).
const TaskPage = () => {
    const { slug } = useParams()
    const history = useHistory()
    const task = findTaskBySlug(slug)

    const [effectiveDate, setEffectiveDate] = useState('')
    const [organization, setOrganization] = useState('')
    const [comment, setComment] = useState('')
    const [submitted, setSubmitted] = useState(false)

    if (!task) {
        return (
            <div>
                <PageTitle title="Task not found" back />
                <div className="task-page-main">
                    <Typography>There is no task at this address.</Typography>
                </div>
            </div>
        )
    }

    const canSubmit = Boolean(effectiveDate && organization)

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!canSubmit) return
        setSubmitted(true)
    }

    if (submitted) {
        return (
            <div>
                <PageTitle title={task.title} back />
                <div className="task-page-main" role="status">
                    <Typography variant="h6" className="task-page-success">Success! Event submitted.</Typography>
                    <Typography>{task.title} has been submitted for approval.</Typography>
                    <div className="change-benefits-btn-container">
                        <Button variant="contained" color="secondary" className="change-benefits-btn1" onClick={() => history.push('/')}>Done</Button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <PageTitle title={task.title} back />
            <form className="task-page-main" onSubmit={handleSubmit} noValidate aria-label={task.title}>
                {task.description && <Typography className="task-page-description">{task.description}</Typography>}

                <div className="task-page-field">
                    <Typography variant="caption" component="label" htmlFor="task-effective-date" className="task-page-label">Effective Date</Typography>
                    <span className="mandatory">*</span>
                    <TextField
                        id="task-effective-date"
                        name="effectiveDate"
                        type="date"
                        required
                        value={effectiveDate}
                        onChange={(e) => setEffectiveDate(e.target.value)}
                        inputProps={{ 'aria-required': true }}
                        InputLabelProps={{ shrink: true }}
                        className="task-page-input"
                    />
                </div>

                <div className="task-page-field">
                    <Typography variant="caption" component="label" htmlFor="task-organization" className="task-page-label">Organization</Typography>
                    <span className="mandatory">*</span>
                    <TextField
                        select
                        id="task-organization"
                        name="organization"
                        required
                        value={organization}
                        onChange={(e) => setOrganization(e.target.value)}
                        SelectProps={{ native: true }}
                        inputProps={{ 'aria-required': true }}
                        className="task-page-input"
                    >
                        <option value="">Select an organization</option>
                        {supervisoryOrganizations.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </TextField>
                </div>

                <div className="task-page-field">
                    <Typography variant="caption" component="label" htmlFor="task-comment" className="task-page-label">Comment</Typography>
                    <textarea
                        id="task-comment"
                        name="comment"
                        className="task-page-comment"
                        rows="3"
                        placeholder="enter your comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    ></textarea>
                </div>

                <div className="change-benefits-btn-container">
                    <Button type="submit" variant="contained" color="secondary" className="change-benefits-btn1" disabled={!canSubmit}>Submit</Button>
                    <Button variant="contained" className="change-benefits-btn2" type="button" onClick={() => history.push('/')}>Cancel</Button>
                </div>
            </form>
        </div>
    )
}

export default TaskPage
